var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "universes-view" },
    [
      _c("header", { staticClass: "universes-view__header" }, [
        _c(
          "div",
          { staticClass: "universes-view__first" },
          [
            _c("h1", { staticClass: "universes-view__title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("UniversesView.label.header.title")) +
                  "\n      "
              ),
            ]),
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "universes-view__button ma-2",
                                attrs: {
                                  outlined: "",
                                  depressed: "",
                                  fab: "",
                                  color: "var(--ds-color-text-1)",
                                },
                                on: { click: _vm.openDashboardModal },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_c("v-icon", [_vm._v("mdi-plus")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("UniversesView.label.header.button"))),
                ]),
              ]
            ),
          ],
          1
        ),
        _c("p", { staticClass: "universes-view__subtitle" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("UniversesView.label.header.subtitle")) +
              "\n    "
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "universes-view__search" },
        [
          _vm._l(_vm.filtersObj, function (filter, index) {
            return _c(
              filter.component,
              _vm._b(
                {
                  key: index,
                  tag: "component",
                  model: {
                    value: _vm.tempFilter[filter.filterType],
                    callback: function ($$v) {
                      _vm.$set(_vm.tempFilter, filter.filterType, $$v)
                    },
                    expression: "tempFilter[filter.filterType]",
                  },
                },
                "component",
                filter.props,
                false
              )
            )
          }),
          _c(
            "div",
            { staticClass: "universes-view__search-buttons" },
            [
              _c(
                "button",
                {
                  staticClass: "universes-view__clear-button",
                  attrs: { light: "" },
                  on: {
                    click: function ($event) {
                      return _vm.clearPage()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("UniversesView.label.button.clearButton")) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "DsButton",
                {
                  attrs: { color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.clearFilters()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("UniversesView.label.button.cancelButton")
                      ) +
                      "\n      "
                  ),
                ]
              ),
              _c(
                "DsButton",
                {
                  attrs: { disabled: _vm.hasFilter },
                  on: {
                    click: function ($event) {
                      return _vm.loadDashboards()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("UniversesView.label.button.applyButton")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("div", { staticClass: "universes-view__separator" }),
      _vm.initialState
        ? _c("div", [_c("div")])
        : _c("div", { staticClass: "universes-view__visualization" }, [
            _vm.error
              ? _c("div", { staticClass: "universes-view__visualization" }, [
                  _c(
                    "div",
                    { staticClass: "universes-view__info" },
                    [
                      _c(
                        "span",
                        { staticClass: "universes-view__info-title" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "UniversesView.label.message.dataLoadingError.title"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c(
                        "p",
                        { staticClass: "universes-view__info-description" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "UniversesView.label.message.dataLoadingError.description"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c(
                        "DsButton",
                        {
                          attrs: { color: "secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.loadDashboards()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "UniversesView.label.button.tryAgainButton"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  { staticClass: "universes-view__visualization" },
                  [
                    _vm.success
                      ? _c("v-data-table", {
                          staticClass: "universes-view__data-table",
                          attrs: {
                            light: "",
                            headers: _vm.headers,
                            items: _vm.dashboards,
                            "items-per-page": 10,
                            search: _vm.search,
                            "loading-text": _vm.$t(
                              "UniversesView.notification.loadingData"
                            ),
                            loading: _vm.loading,
                            "footer-props": {
                              itemsPerPageOptions: _vm.itemsPerPage,
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: `item.expiresTrialDate`,
                                fn: function ({ item }) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getFormattedDate(item))
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: `item.isStaging`,
                                fn: function ({ item }) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getLabel(item))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: `item.userEmails`,
                                fn: function ({ item }) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.getUsers(item))),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: `item.actions`,
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: `https://studio.stilingue.com.br/${item.accountId}/${item.universeId}/dashboard`,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("DsButton", {
                                          attrs: {
                                            icon: "",
                                            name: "link",
                                            color: "ghost",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("DsButton", {
                                      attrs: {
                                        icon: "",
                                        name: "edit",
                                        color: "ghost",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setDashboardToEdit(item)
                                        },
                                      },
                                    }),
                                    _vm.showDeleteDashboardFeature
                                      ? _c("DsButton", {
                                          attrs: {
                                            icon: "",
                                            name: "trash",
                                            color: "ghost",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDeleteModal(item)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _c("div", { staticClass: "universes-view__info" }, [
                          _c(
                            "span",
                            { staticClass: "universes-view__info-title" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "UniversesView.label.message.noDataFinding.title"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "universes-view__info-description" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "UniversesView.label.message.noDataFinding.description"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]),
                  ],
                  1
                ),
          ]),
      _vm.universesModal
        ? _c("UniversesModal", {
            attrs: {
              dashboard: _vm.dashboardToEdit,
              "modal-title": _vm.modalTitle,
            },
            on: { "load-dashboards": _vm.loadDashboards },
            model: {
              value: _vm.universesModal,
              callback: function ($$v) {
                _vm.universesModal = $$v
              },
              expression: "universesModal",
            },
          })
        : _vm._e(),
      _c("DeleteUniverseModal", {
        attrs: { dashboard: _vm.dashboardSelected },
        on: {
          "close-delete-modal": _vm.closeDeleteModal,
          "close-delete-modal-and-reload": _vm.closeDeleteModalAndReload,
        },
        model: {
          value: _vm.deleteModal,
          callback: function ($$v) {
            _vm.deleteModal = $$v
          },
          expression: "deleteModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }